import { orderBy } from 'lodash';

import UrlUtils from '../url-utils';
import StringUtils from '../StringUtils';

import Urls from 'constants/Urls';
import { countryCodes } from 'constants/CountryCodes';
import { WEB_PLATFORM_IS_BUILD_MODE } from 'shared/infra/constants/platform.const';

const isArgentina = countryCode => {
  return countryCode === countryCodes.ARGENTINA;
};
const isBrazil = countryCode => {
  return countryCode === countryCodes.BRAZIL;
};
const isColombia = countryCode => {
  return countryCode === countryCodes.COLOMBIA;
};
const isCostaRica = countryCode => {
  return countryCode === countryCodes.COSTA_RICA;
};
const isChile = countryCode => {
  return countryCode === countryCodes.CHILE;
};
const isEcuador = countryCode => {
  return countryCode === countryCodes.ECUADOR;
};
const isPeru = countryCode => {
  return countryCode === countryCodes.PERU;
};
const isMexico = countryCode => {
  return countryCode === countryCodes.MEXICO;
};
const isUruguay = countryCode => {
  return countryCode === countryCodes.URUGUAY;
};

const sortByName = countrys => {
  return orderBy(countrys, ['name']);
};

const getCountryImageUrl = countryCode => {
  if (!WEB_PLATFORM_IS_BUILD_MODE) {
    return 'https://images.dev.rappi.com';
  }
  switch (countryCode) {
    case countryCodes.COLOMBIA:
      return 'https://images.rappi.com';
    case countryCodes.CHILE:
      return `https://images.rappi.${countryCode}`;
    case countryCodes.ARGENTINA:
      return `https://images.rappi.com.${countryCode}`;
    case countryCodes.BRAZIL:
      return `https://images.rappi.com.${countryCode}`;
    case countryCodes.ECUADOR:
      return `https://images.rappi.com.${countryCode}`;
    case countryCodes.MEXICO:
      return `https://images.rappi.com.${countryCode}`;
    case countryCodes.COSTA_RICA:
      return `https://images-v2.rappi.co.${countryCode}`;
    case countryCodes.PERU:
      return `https://images.rappi.${countryCode}`;
    case countryCodes.URUGUAY:
      return `https://images.rappi.com.${countryCode}`;
    default:
      return `https://images.rappi.com.${countryCode}`;
  }
};

const formatLogoURL = (countryCode, logoURL) => {
  if (StringUtils.isNullOrEmpty(logoURL)) return '';
  let urlImage;
  urlImage = getCountryImageUrl(countryCode);
  const baseUrl = UrlUtils.replaceUrlParams(Urls.RESTAURANTS_LOGO, {
    urlImage,
  });
  return `${baseUrl}/${logoURL}`;
};

function getLinkToRegisterNewAccount(countryCode) {
  return (
    {
      [countryCodes.COLOMBIA]: 'https://merchants.rappi.com/es-co/restaurants',
      [countryCodes.MEXICO]: 'https://merchants.rappi.com/es-mx/restaurants',
      [countryCodes.ARGENTINA]: 'https://merchants.rappi.com/es-ar/restaurants',
      [countryCodes.BRAZIL]: 'https://merchants.rappi.com/pt-br/restaurants',
      [countryCodes.CHILE]: 'https://merchants.rappi.com/es-cl/restaurants',
      [countryCodes.COSTA_RICA]:
        'https://merchants.rappi.com/es-cr/restaurants',
      [countryCodes.ECUADOR]: 'https://merchants.rappi.com/es-ec/restaurants',
      [countryCodes.PERU]: 'https://merchants.rappi.com/es-pe/restaurants',
      [countryCodes.URUGUAY]: 'https://merchants.rappi.com/es-uy/restaurants',
    }[countryCode] ?? process.env.REACT_APP_NEW_ACCOUNT
  );
}

export default {
  isArgentina,
  isBrazil,
  isChile,
  isColombia,
  isCostaRica,
  isEcuador,
  isMexico,
  isPeru,
  isUruguay,
  sortByName,
  formatLogoURL,
  getCountryImageUrl,
  getLinkToRegisterNewAccount,
};
